import type { AirtimeBatch } from "../types";

import AirtimeEmptyState from "./AirtimeEmptyState";

function statusClass(status: string) {

  switch (status) {

    case "COMPLETED":

      return "bg-emerald-100 text-emerald-700";

    case "PROCESSING":

      return "bg-blue-100 text-blue-700";

    case "FAILED":

      return "bg-red-100 text-red-700";

    case "PARTIAL":

      return "bg-amber-100 text-amber-700";

    default:

      return "bg-slate-100 text-slate-700";

  }

}

export default function AirtimeBatchTable({ data }: { data: AirtimeBatch[] }) {

  if (!data.length) {

    return (

      <AirtimeEmptyState

        title="No disbursement history"

        description="No airtime disbursement batches have been created yet."

      />

    );

  }

  return (

    <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm">

      <div className="overflow-x-auto">

        <table className="min-w-full divide-y divide-slate-200">

          <thead className="bg-slate-50">

            <tr>

              <Th>Batch Date</Th>

              <Th>Status</Th>

              <Th>Total Amount</Th>

              <Th>Successful</Th>

              <Th>Failed</Th>

              <Th>Started</Th>

              <Th>Completed</Th>

            </tr>

          </thead>

          <tbody className="divide-y divide-slate-100">

            {data.map((row) => (

              <tr key={row.id} className="hover:bg-slate-50">

                <td className="px-6 py-4 font-semibold text-slate-800">

                  {row.disbursementDate}

                </td>

                <td className="px-6 py-4">

                  <span

                    className={`rounded-full px-3 py-1 text-xs font-black ${statusClass(

                      row.status,

                    )}`}

                  >

                    {row.status}

                  </span>

                </td>

                <td className="px-6 py-4 text-sm font-semibold text-slate-700">

                  KES {row.totalAmount ?? 0}

                </td>

                <td className="px-6 py-4 text-sm font-semibold text-emerald-700">

                  KES {row.successAmount ?? 0}

                </td>

                <td className="px-6 py-4 text-sm font-semibold text-red-600">

                  KES {row.failedAmount ?? 0}

                </td>

                <td className="px-6 py-4 text-sm text-slate-600">

                  {row.startedAt ? new Date(row.startedAt).toLocaleString() : "-"}

                </td>

                <td className="px-6 py-4 text-sm text-slate-600">

                  {row.completedAt ? new Date(row.completedAt).toLocaleString() : "-"}

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>

  );

}

function Th({ children }: { children: React.ReactNode }) {

  return (

    <th className="px-6 py-4 text-left text-xs font-black uppercase tracking-wide text-slate-600">

      {children}

    </th>

  );

}